// removed by extract-text-webpack-plugin
module.exports = {"content":"FollowUp7Day__content__1Ta3j","parentContainer":"FollowUp7Day__parentContainer__1jLj-","searchWrapper":"FollowUp7Day__searchWrapper__yeHsx","searchWrapperLabel":"FollowUp7Day__searchWrapperLabel__3IuDk"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/FollowUp7Day/FollowUp7Day.css
// module id = 2910
// module chunks = 0